var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.teetimePlayers),function(m){return _c('div',{key:m.id},[_c('user-card',{attrs:{"user":m,"type":"user"}})],1)}),_vm._v(" "),_vm._l((_vm.teetimeFills),function(m){return _c('div',{key:m.id},[_c('user-card',{attrs:{"user":m,"type":"fill"}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }